import { render, staticRenderFns } from "./ExpensesSetup.vue?vue&type=template&id=d9207f56&"
import script from "./ExpensesSetup.vue?vue&type=script&lang=js&"
export * from "./ExpensesSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports